// extracted by mini-css-extract-plugin
export var createdDate = "_n4-1";
export var divider = "_n4-2";
export var headerDivider = "_n4-3";
export var messagesCard = "_n4-0";
export var messagesContainer = "_n4-6";
export var messagesContainerWrapper = "_n4-4";
export var showLeftPanelButton = "_n4-8";
export var topButtons = "_n4-7";
export var withPadding = "_n4-5";